import * as React from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster: React.FC<ToasterProps> = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      duration={3000}
      richColors
      closeButton
      position="top-right"
      toastOptions={{
        classNames: {
          toast: "rounded-md border shadow-sm",
          title: "font-medium",
          description: "text-sm opacity-90",
          actionButton: "btn btn-sm",
          cancelButton: "btn btn-sm btn-secondary",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
